export default __webpack_public_path__ + "static/media/Ronnie_Feng_-PortfolioPrint.06f0ec72.webp";